module.exports = __webpack_public_path__ + "img/1513927362.897b61f3.jpg";